<template>
  <div class="amazon-media-multiple-input">
    <div class="form-group" v-bind:class="{ 'has-feedback' : field.dirty }">
      <label v-bind:for="field.name" class="col-sm-4 control-label has-icon has-icon-image">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <div class="image-upload-placeholder btn">
          <input type="file" name="media" v-bind:id="field.name"/>
          <input type="hidden" v-bind:name="field.name" v-bind:id="field.name + '-url'" v-model="field.value"/>
          Choose File(s)
        </div>
        <br/>
        <div v-for="value in field.value">
          Image {{ $index + 1 }}<a v-show="value" v-bind:href="'https://techcar-dev.s3.amazonaws.com/' + value" target="_blank" style="margin-left: 20px;">Preview</a>
          | <a class="interactive-cursor" v-on:click="deleteImage(value)">Remove</a>
        </div>
        <div class="progress" v-show="uploading">
          <div class="progress-bar progress-bar-success" role="progressbar" v-bind:style="{ width: progress + '%' }"></div>
        </div>
        <span class="form-validation-error" v-show="hasError && field.dirty">{{ hasError }}.</span>
        <span class="form-validation-error" v-show="!field.valid && field.dirty">You did not select a file to upload</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmazonMediaMultipleInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: [],
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      progress: 0,
      uploading: false,
      hasError: false
    }
  },
  ready () {
    let token = window.sessionStorage.getItem('token')
    $(`#${this.field.name}`).fileupload({
      url: '/api/public/media-uploader',
      headers: { Authorization: `Bearer ${token}` },
      type: 'POST',
      dataType: 'json',
      sequentialUploads: true,
      add: (e, data) => {
        this.hasError = false
        let uploadErrors = []
        let acceptFileTypes = /^(image\/(gif|jpe?g|png))|(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/
        let file = data.originalFiles[0]
        if (window.File && window.FileList && window.FileReader) {
          if (file.type.length && !acceptFileTypes.test(file.type)) {
            uploadErrors.push('Not an accepted file type')
          }
          if (file.size.length && file.size > 10000000) {
            uploadErrors.push('Filesize is too big')
          }
          if (uploadErrors.length > 0) {
            this.hasError = uploadErrors.join('\n')
          } else {
            data.submit()
          }
        } else {
          data.submit()
        }
      },
      send: (e, data) => {
        this.uploading = true
      },
      progress: (e, data) => {
        this.progress = parseInt(data.loaded / data.total * 100, 10)
      },
      done: (e, data) => {
        this.progress = 0
        this.uploading = false
        this.field.value.push(data.result.key)
      }
    })
    this.validateField(this.field.value)
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.validateField(newVal)
    }
  },
  methods: {
    validateField (val) {
      if (val) {
        this.field.dirty = true
        if (this.field.required) {
          if (this.field.value !== '') this.field.valid = true
        } else {
          this.field.valid = true
        }
      } else if (this.field.required) {
        this.field.valid = false
      } else {
        this.field.valid = true
      }
    },
    deleteImage (image) {
      this.field.value.splice(this.field.value.indexOf(image), 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AmazonMediaMultipleInput.vue?130101e0